import { isPresent } from "@apl-digital/utils";
import i18n from "i18next";

import {
  clearSessionStorage,
  getSessionStorage,
  SessionStorageKey,
  setSessionStorage,
} from "@/base/utils/storage";
import {
  changeSelectedLanguage,
  overrideLanguage,
} from "@/store/language/slice";
import type { AppStartListening } from "@/store/listenerMiddleware";

import { selectCurrentLanguage } from "./selectors";

export const addLanguageListeners = (startListening: AppStartListening) => {
  startListening({
    predicate: (_action, currentState, previousState) =>
      currentState.language.languageOverride !==
      previousState.language.languageOverride,

    effect: (_action, { getState }) => {
      const languageOverride = getState().language.languageOverride;

      if (isPresent(languageOverride)) {
        setSessionStorage(
          SessionStorageKey.LANGUAGE_OVERRIDE,
          languageOverride,
        );
      } else {
        clearSessionStorage(SessionStorageKey.LANGUAGE_OVERRIDE);
      }
    },
  });

  startListening({
    predicate: (action, currentState, previousState) =>
      selectCurrentLanguage(previousState) !==
        selectCurrentLanguage(currentState) ||
      overrideLanguage.match(action) ||
      changeSelectedLanguage.match(action),

    effect: async (_action, { getState }) => {
      const currentLanguage = selectCurrentLanguage(getState());

      if (i18n.language !== currentLanguage) {
        if (i18n.isInitialized) {
          await i18n.changeLanguage(currentLanguage);
        } else {
          i18n.on("initialized", () => {
            void i18n.changeLanguage(currentLanguage);
          });
        }
      }
    },
  });

  startListening({
    predicate: (_action, currentState, previousState) =>
      selectCurrentLanguage(previousState) !==
        selectCurrentLanguage(currentState) ||
      (isPresent(selectCurrentLanguage(currentState)) &&
        !isPresent(getSessionStorage(SessionStorageKey.LANGUAGE_CURRENT))),

    effect: (_action, { getState }) => {
      const currentLanguage = selectCurrentLanguage(getState());

      if (isPresent(currentLanguage)) {
        setSessionStorage(SessionStorageKey.LANGUAGE_CURRENT, currentLanguage);
      } else {
        clearSessionStorage(SessionStorageKey.LANGUAGE_CURRENT);
      }
    },
  });
};
